<template>
	<div :name="name" class="w5-file-component" @click="clearErrors">

		<!-- итем -->
		<div v-if="currentValue && typeof currentValue === 'object'" class="w5-file-uploader-item">
			<!-- враппер картинки -->
			<div class="w5-file-uploader-item-image-wrapper">
				<div class="attach-no-image-preview-file-uploader">{{ currentValue.ext }}</div>
			</div>
			<!-- название файла -->
			<div class="w5-file-uploader-item-title">{{ currentValue.title | ftc }}</div>
			<!-- размер файла -->
			<div class="w5-file-uploader-item-size">
				<span v-if="(currentValue.status === '' || currentValue.status === 'done') && currentValue.size">{{ currentValue.size | bytes }}</span>
				<span v-if="currentValue.status === 'loading' || currentValue.status === 'uploading'" class="font-size-85"><img src="/static/img/loading-hor16.gif" /><br>{{ currentValue.progress ? currentValue.progress : '' }}</span>
			</div>
			<!-- блок загрузчика и кнопки удаления -->
			<div class="w5-file-uploader-item-buttons">
				<font-awesome-icon v-if="currentValue.status === 'done'"
					:title="'main/delete' | ftc"
					@click="deleteItem"
					icon="trash-alt"
				/>
				<font-awesome-icon v-if="currentValue.status === 'loading' || currentValue.status === 'uploading'"
					:title="'main/cancel' | ftc"
					@click="cancelUploading"
					icon="times-circle"
				/>
			</div>
		</div>

		<!-- кнопка аттача файла -->
		<span v-show="buttonVisibility" class="w5-file-add-button">
			<font-awesome-icon icon="paperclip" /><div class="w5-file-add-button-caption">{{ buttonTitle }}</div>
			<input type="file"
				ref="fileUploaderInput"
				name="w5-file-uploader"
				@change="onSelect" />
		</span>
		<span class="clearfix"></span>

		<!-- Блок с ошибками -->
		<div v-show="errors !== ''" class="alert alert-danger w5-alert-valid" role="alert" v-withSafeTags="localeFtc(errors)"></div>

	</div>
</template>

<script>
///////////////////////////////////////////////////////////////////////////////
import Helper from '@/helper/helper'
import $ from 'jquery'
import { EventBus } from '@/bus.js'
///////////////////////////////////////////////////////////////////////////////
export default {
	//=========================================================================
	name: 'directFileComponent',

	//=========================================================================
	props: ['name', 'title', 'value', 'accept', 'maxsize', 'maxcnt', 'formFields'],

	//=========================================================================
	computed: {
		//---------------------------------------------------------------------
		// заголовок кнопки
		//---------------------------------------------------------------------
		buttonTitle() {
			let _title = this.localeFtc(this.title).toLowerCase()
			return this.formater_capitalizeFirstChar(_title)
		},
		//---------------------------------------------------------------------
		// видима кнопка или нет
		//---------------------------------------------------------------------
		buttonVisibility() {
			if (this.currentValue)
				// если еще нет значения
				return false
			else
				// если уже есть значение
				return true
		}

		//---------------------------------------------------------------------
	},

	//=========================================================================
	data() {
		return {
			// значение поля
			currentValue: null,

			// ошибки загрузки
			errors: ''
		}
	},

	//=========================================================================
	mounted() {
		EventBus.$on('w5-iso-form-upload', this.startUpload)
	},

	//=========================================================================
	beforeDestroy() {
		EventBus.$off('w5-iso-form-upload', this.startUpload)
	},

	//=========================================================================
	methods: {
		//---------------------------------------------------------------------
		// выбрали файл
		//---------------------------------------------------------------------
		onSelect(e) {
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// получим выбранные файлы
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			this.errors = ''
			let files = e.target.files
			let len = files['length']
			// если файлов нет - ничего не делаем
			if (len <= 0) return

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// проверка типа
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			let _id = ''
			let _type = ''
			let _isAcceptType = false
			let _ans = null
			let i = 0

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// по умолчанию запрещенный тип
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			_isAcceptType = false

			// определим тип
			_ans = this.verifyFileType(files[i])
			_isAcceptType = _ans['isAccept']
			_type = _ans['type']

			// если тип запрещен (или не определился)
			if (!_isAcceptType)
			{
				if (this.errors === '') this.errors = '<b>' + files[i]['name'] + '</b> upload/incorrect_filetype'
				else this.errors += '<br><b>' + files[i]['name'] + '</b> upload/incorrect_filetype'
				return
			}
			else
			{
				// запомним тип, если это массив
				if ($.isArray(_type) && _type.length) _type = _type[0]
			}

			// еще раз проверим итоговый тип
			if (_type === undefined || _type === null || $.trim(_type) === '')
			{
				if (this.errors === '') this.errors = '<b>' + files[i]['name'] + '</b> upload/incorrect_filetype'
				else this.errors += '<br><b>' + files[i]['name'] + '</b> upload/incorrect_filetype'
				return
			}

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// проверка на размер файла
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			if (files[i]['size'] > this.maxsize)
			{
				// формируем текст ошибки
				if (this.errors === '') this.errors = '<b>' + files[i]['name'] + '</b> upload/too_big_file (max: ' + Helper.FormatBytes(this.maxsize) + ')'
				else this.errors += '<br><b>' + files[i]['name'] + '</b> upload/too_big_file (max: ' + Helper.FormatBytes(this.maxsize) + ')'
				return
			}

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// проверка на количество файлов
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			if (len >= this.maxcount)
			{
				// формируем текст ошибки
				if (this.errors === '') this.errors = '<b>' + files[i]['name'] + '</b> ' + this.localeFtc('main/max_files_error').replace('{max}', this.maxcount)
				else this.errors += '<br><b>' + files[i]['name'] + '</b> ' + this.localeFtc('main/max_files_error').replace('{max}', this.maxcount)
				return
			}

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// запоминаем
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// уникальный ключ
			_id = Helper.unixTime(true)

			this.currentValue = {
				'id': _id,
				'url': files[i]['name'],
				'type': _type,
				'ext': Helper.getFileExt(files[i]['name']).toUpperCase().substr(0, 4),
				'title': files[i]['name'],
				'status': 'done',
				'size': files[i] && files[i]['size'] ? files[i]['size'] : 0,
				'local': files[i]
			}

			// сообщим родителю
			this.$emit('focus')
			this.$emit('input', _id)
		},

		//---------------------------------------------------------------------
		// обнуление ошибок
		//---------------------------------------------------------------------
		clearErrors() {
			this.errors = ''
		},

		//---------------------------------------------------------------------
		// удаление текущего выбора
		//---------------------------------------------------------------------
		deleteItem() {
			// обнуляем ошибку
			this.errors = ''

			// просто чистим значение
			this.currentValue = null

			// сообщим родителю
			this.$emit('input', null)
		},

		//---------------------------------------------------------------------
		// старт загрузки файла
		//---------------------------------------------------------------------
		startUpload(url) {
			// обнуляем ошибку
			this.errors = ''

			// если нет значения
			if (!this.currentValue)
			{
				this.errors = 'main/no_data'
				return
			}

			// запоминаем контекст
			let _this = this

			// формируем данные для передачи
			let _formData = new FormData()
			_formData.append('file', this.currentValue['local'])

			// начинаем загрузку
			this.currentValue['status'] = 'uploading'
			this.currentValue['progress'] = 0

			// старый, добрый Ajax
			this.currentValue['xhr'] = $.ajax({
				// стандартные настройки
				type: 'POST',
				url: url,
				data: _formData,
				cache: false,
				contentType: false,
				processData: false,
				// определим объект запроса с дополнительным обработчиком события "progress"
				xhr: function() {
					var xhr = new XMLHttpRequest()
					// прогресс загрузки на сервер
					xhr.upload.addEventListener('progress', function(evt) {
						if (evt.lengthComputable && _this.currentValue)
						{
							let percentComplete = evt.loaded / (evt.total ? evt.total : 1) * 100.0
							_this.currentValue['progress'] = percentComplete.toFixed(0) + '%'
							_this.$forceUpdate()
						}
					}, false)
					return xhr
				},
				// перед запросом
				beforeSend: function(xhr, obj) {
					// увеличим счетчик активных загрузок файлов
					_this.$store.commit('uploadFileCounter', '+')
					// форма изменена
					_this.$store.commit('changedForm', _this.$route.path)
				},
				// при упешном ответе сервера
				success: function(data, txt, xhr) {
					// файл успешно загружен на сервер, и мы получили ключ файла
					if (data && 'status' in data && data['status'] === 'ok')
					{
						// обновим UI
						_this.$forceUpdate()
						// дадим знать родителю что закончилась закачка
						_this.$emit('uploadFinished')
						// все
						return
					}

					// ошибка
					_this.currentValue = null
					_this.$emit('input', null)
					_this.$emit('uploadError', 'upload/some_error')
				},
				// ошибка загрузки
				error: function(data) {
					// если это мы прервали загрузку - ничего не делаем
					if (data.statusText === 'abort') return
					// ошибка
					_this.currentValue = null
					_this.$emit('input', null)
					_this.$emit('uploadError', 'upload/some_error')
				},
				// при любом результате
				complete: function(jqXHR, textStatus) {
					// уменьшим счетчик активных загрузок файлов
					_this.$store.commit('uploadFileCounter', '-')
					// меняем статус
					if (this.currentValue && this.currentValue['status'])
						this.currentValue['status'] = 'done'
				}
			})
		},

		//---------------------------------------------------------------------
		// отмена загрузки файла
		//---------------------------------------------------------------------
		cancelUploading() {
			// проверка параметра
			if (!this.currentValue || !this.currentValue.xhr)
				return

			this.currentValue.xhr.abort()

			// удаляем
			this.currentValue = null
			this.$emit('input', null)

			// сообщаем родителям что прервали загрузку
			this.$emit('uploadCanceled')
		},

		//---------------------------------------------------------------------
		// проверка типа файла
		//---------------------------------------------------------------------
		verifyFileType(File) {
			// готовим ответ
			let _ans = {
				'isAccept': false,
				'type': null
			}

			// 1. сначала пытаемся определить тип файла по расширению
			// получим все типы по расширению файла (массив)
			let _type = this.getTypeByName(File['name'], true)

			// бежим по полученному массиву типов
			for (let x = 0; x < _type.length; x++)
			{
				// текущий тип
				let _v = _type[x]

				// если допустимый тип это массив (список)
				if ($.isArray(this.accept))
				{
					// если есть в списке
					if ($.inArray(_v, this.accept) >= 0)
					{
						// у нас есть ответ
						_ans['isAccept'] = true
						_ans['type'] = _v
						return _ans
					}
				}
				// если допустимый тип это просто строка
				else if (typeof this.accept === 'string')
				{
					if (_v.match(this.accept))
					{
						// у нас есть ответ
						_ans['isAccept'] = true
						_ans['type'] = _v
						return _ans
					}
				}
			}

			// 2. если дошли до сюда, значит не удалось определить тип по расширению
			// будем пытаться определить тип если MIME тип определился браузером
			if (File['type'] !== '')
			{
				// запоминаем тип
				_type = File['type']
				// проверяем его
				if ($.isArray(this.accept))
				{
					if ($.inArray(_type, this.accept) >= 0)
					{
						// у нас есть ответ
						_ans['isAccept'] = true
						_ans['type'] = _type
						return _ans
					}
				}
				else if (typeof this.accept === 'string')
				{
					if (_type.match(this.accept))
					{
						// у нас есть ответ
						_ans['isAccept'] = true
						_ans['type'] = _type
						return _ans
					}
				}
			}

			// так и не удалось получить тип
			return _ans
		},

		//---------------------------------------------------------------------
		// получение типа файла по его названию
		//---------------------------------------------------------------------
		getTypeByName(value, all) {
			// получим расширение файла и будем смотреть на него
			let _ext = Helper.getFileExt(value).toLowerCase()
			// получим по расширению MIME тип
			let _arr = []
			_arr.push(_ext)

			let _type = this.getMimes(_arr)

			// если требуется только первый тип
			if (!all)
			{
				if (_type.length) _type = _type[0]
				else _type = 'unknown'
			}

			// вренем массив
			return _type
		},

		//---------------------------------------------------------------------
		// получение MIME по расширению файла
		//---------------------------------------------------------------------
		getMimes(extensions) {
			// MIME типы
			let _mimeTypes = {
				'csv': ['text/x-comma-separated-values', 'text/comma-separated-values', 'application/octet-stream', 'text/csv', 'application/csv'],
				'bin': 'application/octet-stream',
				'psd': 'application/x-photoshop',
				'oda': 'application/oda',
				'pdf': ['application/pdf', 'application/x-download'],
				'ai': 'application/postscript',
				'eps': 'application/postscript',
				'ps': 'application/postscript',
				'xls': ['application/excel', 'application/vnd.ms-excel', 'application/msexcel'],
				'ppt': ['application/powerpoint', 'application/vnd.ms-powerpoint'],
				'wbxml': 'application/wbxml',
				'wmlc': 'application/wmlc',
				'gtar': 'application/x-gtar',
				'gz': 'application/x-gzip',
				'swf': 'application/x-shockwave-flash',
				'tar': 'application/x-tar',
				'tgz': 'application/x-tar',
				'xhtml': 'application/xhtml+xml',
				'xht': 'application/xhtml+xml',
				'zip': ['application/x-zip', 'application/zip', 'application/x-zip-compressed'],
				'mid': 'audio/midi',
				'midi': 'audio/midi',
				'mpga': 'audio/mpeg',
				'mp2': 'audio/mpeg',
				'mp3': ['audio/mpeg', 'audio/mpg'],
				'aif': 'audio/x-aiff',
				'aiff': 'audio/x-aiff',
				'aifc': 'audio/x-aiff',
				'ram': 'audio/x-pn-realaudio',
				'rm': 'audio/x-pn-realaudio',
				'rpm': 'audio/x-pn-realaudio-plugin',
				'ra': 'audio/x-realaudio',
				'rv': 'video/vnd.rn-realvideo',
				'wav': 'audio/x-wav',
				'bmp': 'image/bmp',
				'gif': 'image/gif',
				'jpeg': ['image/jpeg', 'image/pjpeg'],
				'jpg': ['image/jpeg', 'image/pjpeg'],
				'jpe': ['image/jpeg', 'image/pjpeg'],
				'png': ['image/png', 'image/x-png'],
				'tiff': 'image/tiff',
				'tif': 'image/tiff',
				'css': 'text/css',
				'html': 'text/html',
				'htm': 'text/html',
				'shtml': 'text/html',
				'txt': 'text/plain',
				'text': 'text/plain',
				'log': ['text/plain', 'text/x-log'],
				'rtx': 'text/richtext',
				'rtf': 'text/rtf',
				'xml': 'text/xml',
				'xsl': 'text/xml',
				'mpeg': 'video/mpeg',
				'mpg': 'video/mpeg',
				'mpe': 'video/mpeg',
				'qt': 'video/quicktime',
				'mov': 'video/quicktime',
				'avi': 'video/x-msvideo',
				'movie': 'video/x-sgi-movie',
				'doc': 'application/msword',
				'docx': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
				'xlsx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
				'word': ['application/msword', 'application/octet-stream'],
				'xl': 'application/excel',
				'eml': 'message/rfc822',
				'iso': ['application/x-iso9660-image', 'application/x-iso-image'],
				'sig': 'application/octet-stream'
			}

			let mimes = []
			for (let i in extensions)
			{
				let ext = extensions[i]

				if (ext in _mimeTypes)
				{
					let mime = _mimeTypes[ext]

					if ($.isArray(mime))
						$.merge(mimes, mime)
					else
						mimes.push(mime)
				}
			}

			return mimes
		}

		//---------------------------------------------------------------------
	}

	//=========================================================================
}
///////////////////////////////////////////////////////////////////////////////
</script>



// WEBPACK FOOTER //
// directFile.vue?8a844b2e